import { Box, Typography, useTheme } from '@mui/material';
import FAQSection from './components/faqs';
import Footer from './components/footer';
import Hero from './components/hero';
import InitiativeSection from './components/initiative';
import Navbar from './components/navbar';
import SpotlightSection from './components/spotlight';
import WhatToExpect from './components/whatToExpect';
import { useContext, useEffect, useRef, useState } from 'react';
import { useSnackbar } from 'notistack';
import { useLocation } from 'react-router-dom';
import { AuthContext } from '../../Helpers/Contexts/authContext';
import Partners from './components/partners';
import HowItWorks from './components/HowItWorks';
import turbo from '../../Assets/images/turbo.svg';
import wiz from '../../Assets/images/wizcraft2.svg';
import house from '../../Assets/images/house.svg';
import iitm from '../../Assets/images/iitmg.svg';

const MainScreen = () => {
  const { pathname } = useLocation();
  const { dispatch } = useContext(AuthContext);
  const [hasLoggedOut, setHasLoggedOut] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const theme = useTheme();

  const aboutRef = useRef<HTMLDivElement | null>(null);
  const HIWRef = useRef<HTMLDivElement | null>(null);
  const FAQRef = useRef<HTMLDivElement | null>(null);
  const homeRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (pathname === '/' && !hasLoggedOut) {
      dispatch({ type: 'LOGOUT' });
      localStorage.clear();
      // enqueueSnackbar('You have been logged out.', { variant: 'error' });
      setHasLoggedOut(true);
    }
  }, [pathname, hasLoggedOut, dispatch, enqueueSnackbar]);

  return (
    <Box id="scroll-container" sx={{ height: '100vh', overflowY: 'auto', scrollBehavior: 'smooth' }}>
      <Box sx={{ position: 'relative', zIndex: 1000 }}>
        <div ref={homeRef} style={{ height: '0px', background: 'black' }} />

        <Navbar aboutRef={aboutRef} HIWRef={HIWRef} FAQRef={FAQRef} HomeRef={homeRef} />
      </Box>
      <Box
        sx={{
          position: 'sticky',
          height: '100vh',
          top: 0,
          left: 0,
          width: '100%',
          zIndex: 1,
        }}
      >
        <Hero />
      </Box>
      <Box
        sx={{
          position: 'relative',
          zIndex: 1,
          backgroundColor: 'transparent',
          minHeight: '100vh',
        }}
      >
        <div ref={aboutRef}>
          <WhatToExpect />
        </div>
        <Partners />
        <SpotlightSection />
        <div ref={HIWRef}>
          <InitiativeSection />
        </div>
        {/* <MeetTheTeam /> */}
        {/* <TestimonialSection /> */}
        <HowItWorks />
        <div ref={FAQRef}>
          <FAQSection />
        </div>
        {/* Fixed Bottom Banner */}
        <Box
          sx={(theme) => ({
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            width: '100%',
            height: '80px',
            background: 'rgba(0, 0, 0, 0.15)',
            backdropFilter: 'blur(10px)',
            WebkitBackdropFilter: 'blur(10px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            px: { xs: '10px', md: '20px' },
            py: '10px',
            gap: { xs: '20px', md: '40px' },
            zIndex: 99999,
            overflow: 'hidden',
            boxShadow: '0 -4px 20px rgba(0, 0, 0, 0.3)',
            borderTop: '1px solid #333',
            [theme.breakpoints.down('md')]: {
              height: '80px',
              gap: '16px',
              px: '12px',
            },
          })}
        >
          {/* Official Curation Partner Section */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              justifyContent: 'flex-start',
              gap: { xs: '5px', md: '8px' },
            }}
          >
            <Typography
              variant="body2"
              sx={{
                color: '#888',
                fontSize: { xs: '10px', md: '12px' },
                fontWeight: 300,
              }}
            >
              Official Curation Partner
            </Typography>
            <Box
              component="img"
              src={turbo}
              alt="Idea Logo"
              sx={{
                width: { xs: '60px', sm: '80px', md: '110px' },
                height: { xs: '30px', sm: '40px', md: '50px' },
                objectFit: 'contain',
              }}
            />
          </Box>

          {/* Divider */}
          <Box
            sx={(theme) => ({
              width: '1px',
              height: '70px',
              backgroundColor: '#444',
              [theme.breakpoints.down('md')]: { height: '50px' },
            })}
          />

          {/* Entertainment Partners Section */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              justifyContent: 'flex-start',
              gap: { xs: '5px', md: '8px' },
            }}
          >
            <Typography
              variant="body2"
              sx={{
                color: '#888',
                fontSize: { xs: '10px', md: '12px' },
                fontWeight: 300,
              }}
            >
              Strategy Partners{' '}
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: '8px', md: '10px' } }}>
              <Box
                component="img"
                src={wiz}
                alt="Partner Logo 1"
                sx={{
                  width: { xs: '60px', sm: '80px', md: '100px', lg: '120px' },
                  height: { xs: '30px', sm: '32px', md: '40px', lg: '50px' },
                  objectFit: 'contain',
                }}
              />
              <Box sx={(theme) => ({ width: '1px', height: '40px', backgroundColor: '#555', [theme.breakpoints.down('md')]: { height: '30px' } })} />
              <Box
                component="img"
                src={house}
                alt="Partner Logo 1"
                sx={{
                  width: { xs: '60px', sm: '80px', md: '120px', lg: '160px' },
                  height: { xs: '30px', sm: '32px', md: '40px', lg: '50px' },
                  objectFit: 'contain',
                }}
              />
            </Box>
          </Box>

          {/* Divider */}
          <Box
            sx={(theme) => ({
              width: '1px',
              height: '90px',
              backgroundColor: '#444',
              [theme.breakpoints.down('md')]: { height: '50px' },
            })}
          />

          {/* Knowledge Partners Section */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              justifyContent: 'flex-start',
              gap: { xs: '5px', md: '8px' },
            }}
          >
            <Typography
              variant="body2"
              sx={{
                color: '#888',
                fontSize: { xs: '10px', md: '12px' },
                fontWeight: 300,
              }}
            >
              Knowledge Partner
            </Typography>
            <Box
              component="img"
              src={iitm}
              alt="IITM Logo"
              sx={{
                width: { xs: '80px', sm: '100px', md: '120px' },
                height: { xs: '32px', sm: '40px', md: '50px' },
                objectFit: 'contain',
              }}
            />
          </Box>
        </Box>
        <Footer />
      </Box>
    </Box>
  );
};

export default MainScreen;
